import type { FC } from 'react';
import { toIso } from '../utils/format';

interface DateRangePickerProps {
  from: string;
  to: string;
  onChange: (range: { from: string; to: string }) => void;
}

export const DateRangePicker: FC<DateRangePickerProps> = ({ from, to, onChange }) => {
  const setPreset = (days: number) => {
    const end = new Date();
    end.setUTCDate(end.getUTCDate() - 1);
    const start = new Date(end);
    start.setUTCDate(start.getUTCDate() - days);
    onChange({ from: toIso(start), to: toIso(end) });
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <input
        type="date"
        className="form-control form-control-sm"
        style={{ width: 150 }}
        value={from}
        max={to}
        onChange={(e) => onChange({ from: e.target.value, to })}
      />
      <span className="text-muted small">→</span>
      <input
        type="date"
        className="form-control form-control-sm"
        style={{ width: 150 }}
        value={to}
        min={from}
        onChange={(e) => onChange({ from, to: e.target.value })}
      />
      <div className="btn-group btn-group-sm">
        <button type="button" className="btn btn-outline-secondary" onClick={() => setPreset(7)}>7d</button>
        <button type="button" className="btn btn-outline-secondary" onClick={() => setPreset(30)}>30d</button>
        <button type="button" className="btn btn-outline-secondary" onClick={() => setPreset(90)}>90d</button>
      </div>
    </div>
  );
};
